import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input } from 'reactstrap';

class Plan extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.avanzar}
                postUrl={api.proyectos.solicitudes.avanzar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud generó el Plan de Trabajo con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Generar Plan de Trabajo"}
                buttonTitle={"Generar Plan de Trabajo"}
                buttonIcon={"fa fa-play fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                
                notAllowedMessage={"La Solicitud ya generó el Plan de Trabajo."}
                saveButton={true}
                saveButtonLabel={"Generar"}
                buttonClass={"btn-success btn-next"}
                closeButton={true}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la solicitud</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Código</Label>
                                <Input disabled={true} type="text" name={"codigo"} />
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Título</Label>
                                <Input disabled={true} type="text" name={"nombre"} />
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Plan;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Plan.js